import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiUrl: string;
  wsUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig | null = null;
  private loadPromise: Promise<AppConfig> | null = null;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<AppConfig> {
    if (this.config) {
      return this.config;
    }

    // Wenn bereits ein Load läuft, warte darauf
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = (async () => {
      try {
        // Versuche ConfigMap zu laden
        this.config = await firstValueFrom(
          this.http.get<AppConfig>('/assets/config.json')
        );
        console.log('Config loaded from ConfigMap:', this.config);
      } catch (error) {
        console.warn('Could not load config.json, using defaults', error);
        // Fallback für lokale Entwicklung
        this.config = {
          apiUrl: '/api',
          wsUrl: '',
        };
      }
      return this.config!;
    })();

    return this.loadPromise;
  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return this.config;
  }
}
